<template>
    <div
        class="app-container clearfix"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.2)"
    >
        <el-row style="padding-bottom: 15px">
            <el-col :span="24">
                <h3 class="headtitle">基础档案编辑</h3>
                <span>{{ basicModule }}-{{ basicType }}对照</span>
                <el-button
                    icon="el-icon-back"
                    type="primary"
                    class="pull-right"
                    @click="backTo"
                    size="medium"
                    >返回</el-button
                >
            </el-col>
        </el-row>

        <div v-if="isDept && isPos">
            <PosDept
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            ></PosDept>
        </div>

        <div v-if="isMultiOrg && isPos">
            <PosMultiOrg
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></PosMultiOrg>
        </div>
        <div v-if="isCustomer && isPos">
            <PosCustomer
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            ></PosCustomer>
        </div>
        <div v-if="isSupplier && isPos">
            <PosSupplier
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            ></PosSupplier>
        </div>

        <div v-if="isPaywayFeeType && isPos">
            <PosPaywayFeeType
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            ></PosPaywayFeeType>
        </div>

        <div v-if="isContactUnit && isPos">
            <PosContactUnit
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            >
            </PosContactUnit>
        </div>

        <div v-if="isOtherRec && isPos">
            <PosOtherRec
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            ></PosOtherRec>
        </div>

        <div v-if="isItem && isPos">
            <PosItem
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></PosItem>
        </div>

        <div v-if="isItemClass && isPos">
            <PosItemClass
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></PosItemClass>
        </div>
        <div v-if="isItemClassShop && isPos">
            <PosItemClassShop
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></PosItemClassShop>
        </div>
        <div v-if="isBankAccount && isPos">
            <PosBankAccount
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></PosBankAccount>
        </div>
        <div v-if="isPaywayUser && isPos">
            <PosPaywayUser
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></PosPaywayUser>
        </div>

        <div v-if="isPayway && isPos">
            <PosPayway
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            ></PosPayway>
        </div>

        <div v-if="isDeptPayway && isPos">
            <PosDeptPayway
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            ></PosDeptPayway>
        </div>

        <div v-if="isKeepAccount && isPos">
            <PosKeepAccount
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            >
            </PosKeepAccount>
        </div>
        <!-- <div v-if="isPos">
            <PosCommon
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></PosCommon>
        </div> -->

        <div v-if="isPayway && isCloud">
            <CloudCustomerPayway
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudCustomerPayway>
        </div>

        <div v-if="isBankAccount && isCloud">
            <CloudBankAccount
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudBankAccount>
        </div>

        <div v-if="isContactUnit && isCloud">
            <CloudContactUnit
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            >
            </CloudContactUnit>
        </div>

        <div v-if="isContactUnitAccount && isCloud">
            <CloudContactUnitAccount
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            >
            </CloudContactUnitAccount>
        </div>
        <div v-if="isMultiOrg && isCloud">
            <CloudMultiOrg
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudMultiOrg>
        </div>
        <div v-if="isDept && isCloud">
            <CloudDept
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            ></CloudDept>
        </div>

        <div v-if="isBillType && isCloud">
            <CloudBillType
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudBillType>
        </div>

        <div v-if="isBillBusType && isCloud">
            <CloudBillBusType
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudBillBusType>
        </div>

        <div v-if="isUnit && isCloud">
            <CloudUnit
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudUnit>
        </div>

        <div v-if="isItem && isCloud">
            <CloudItem
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudItem>
        </div>

        <div v-if="isItemClass && isCloud">
            <CloudItemClass
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudItemClass>
        </div>
        <div v-if="isItemClassDept && isCloud">
            <CloudItemClassDept
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudItemClassDept>
        </div>

        <div v-if="isItemFeeType && isCloud">
            <CloudItemFeeType
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudItemFeeType>
        </div>

        <div v-if="isCustomer && isCloud">
            <CloudCustomer
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            ></CloudCustomer>
        </div>

        <div v-if="isSupplier && isCloud">
            <CloudSupplier
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
                :syncMode="syncMode"
            ></CloudSupplier>
        </div>

        <div v-if="isSupplierType && isCloud">
            <CloudSupplierType
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudSupplierType>
        </div>

        <div v-if="isWareHouse && isCloud">
            <CloudWarehouse
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudWarehouse>
        </div>

        <div v-if="isOrgStore && isCloud">
            <CloudOrgStore
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudOrgStore>
        </div>

        <div v-if="isOrgSupplier && isCloud">
            <CloudOrgSupplier
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudOrgSupplier>
        </div>

        <div v-if="isSupplierOrg && isCloud">
            <CloudSupplierOrg
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudSupplierOrg>
        </div>

        <div v-if="isCustomerShop && isCloud">
            <CloudCustomerShop
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudCustomerShop>
        </div>
        <div v-if="isShop && isCloud">
            <CloudShop
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CloudShop>
        </div>
        <!-- <div v-if="isCloud">
      <CloudCommon
        :openloading="openloadingHandler"
        :closeloading="closeloadingHandler"
        :brandId="brandid"
      ></CloudCommon>
    </div> -->

        <div v-if="isMultiOrg && isCrm">
            <CrmMultiOrg
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CrmMultiOrg>
        </div>
        <div v-if="isShop && isCrm">
            <CrmShops
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CrmShops>
        </div>
        <div v-if="isCustomer && isCrm">
            <CrmCustomer
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CrmCustomer>
        </div>

        <div v-if="isBankAccount && isCrm">
            <CrmBankAccount
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CrmBankAccount>
        </div>
        <div v-if="isCardType && isCrm">
            <CrmCardType
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CrmCardType>
        </div>

        <div v-if="isPayway && isCrm">
            <CrmPayway
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CrmPayway>
        </div>
        <div v-if="isDeptPayway && isCrm">
            <CrmDeptPayway
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CrmDeptPayway>
        </div>

        <!-- <div v-if="isCrm">
            <CrmCommon
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></CrmCommon>
        </div> -->
        <div v-if="isZ5">
            <Z5CloudCommon
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></Z5CloudCommon>
        </div>

        <div v-if="isSCM8">
            <SCM8Common
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></SCM8Common>
        </div>

        <div v-if="isSaiHu">
            <SaiHuCommon
                :openloading="openloadingHandler"
                :closeloading="closeloadingHandler"
                :brandId="brandid"
            ></SaiHuCommon>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
import pagerBar from '@/views/pager/pagerBar'
import PosDept from '@/views/bench/PosDept.vue'
import PosMultiOrg from '@/views/bench/PosMultiOrg.vue'
import PosCustomer from '@/views/bench/PosCustomer.vue'
import PosSupplier from '@/views/bench/PosSupplier.vue'
import PosItem from '@/views/bench/PosItem.vue'
import PosItemClass from '@/views/bench/PosItemClass.vue'
import PosPaywayFeeType from '@/views/bench/PosPaywayFeeType.vue'
import PosPaywayUser from '@/views/bench/PosPaywayToUsers.vue'
import PosBankAccount from '@/views/bench/PosAccount.vue'
import PosOtherRec from '@/views/bench/PosOtherRec.vue'
import PosItemClassShop from '@/views/bench/PosItemClassShop.vue'
import PosContactUnit from '@/views/bench/PosContactUnit.vue'
import PosPayway from '@/views/bench/PosPayway.vue'
import PosDeptPayway from '@/views/bench/PosDeptPayway.vue'
import PosKeepAccount from '@/views/bench/PosKeepAccountInfo.vue'

import CloudContactUnitAccount from '@/views/bench/CloudContactUnitAccount.vue'

import CloudContactUnit from '@/views/bench/CloudContactUnit.vue'
import CloudDept from '@/views/bench/CloudDept.vue'
import CloudBillType from '@/views/bench/CloudBillType.vue'
import CloudBillBusType from '@/views/bench/CloudBillBusType.vue'
import CloudBankAccount from '@/views/bench/CloudBankAccount.vue'

import CloudCustomerPayway from '@/views/bench/CloudCustomerPayway.vue'
import CloudItemClassDept from '@/views/bench/CloudItemClassDept.vue'
import CloudUnit from '@/views/bench/CloudUnit.vue'
import CloudItem from '@/views/bench/CloudItem.vue'
import CloudItemClass from '@/views/bench/CloudItemClass.vue'
import CloudItemFeeType from '@/views/bench/CloudItemFeeType.vue'
import CloudCustomer from '@/views/bench/CloudCustomer.vue'
import CloudSupplier from '@/views/bench/CloudSupplier.vue'
import CloudSupplierType from '@/views/bench/CloudSupplierType.vue'
import CloudWarehouse from '@/views/bench/CloudWarehouse.vue'
import CloudMultiOrg from '@/views/bench/CloudMultiOrg.vue'
import CloudOrgStore from '@/views/bench/CloudOrgStore.vue'
import CloudShop from '@/views/bench/CloudShop.vue'
import CloudOrgSupplier from '@/views/bench/CloudOrgSupplier.vue'
import CloudSupplierOrg from '@/views/bench/CloudSupplierOrg.vue'
import CloudCustomerShop from '@/views/bench/CloudCustomerShop.vue'

import CrmMultiOrg from '@/views/bench/CrmMultiOrg.vue'
import CrmShops from '@/views/bench/CrmShop.vue'
import CrmCustomer from '@/views/bench/CrmCustomer.vue'
import CrmBankAccount from '@/views/bench/CrmAccount.vue'

import CrmCardType from '@/views/bench/CrmCardType.vue'
import CrmPayway from '@/views/bench/CrmPayway.vue'
import CrmDeptPayway from '@/views/bench/CrmDeptPayway.vue'

import CloudCommon from '@/views/bench/CloudCommon.vue'
import PosCommon from '@/views/bench/PosCommon.vue'
import CrmCommon from '@/views/bench/CrmCommon.vue'
import SCM8Common from '@/views/bench/SCM8Common.vue'
import SaiHuCommon from '@/views/bench/SaiHuCommon.vue'

import Z5CloudCommon from '@/views/bench/Z5CloudCommon.vue'
export default {
    components: {
        SCM8Common,
        SaiHuCommon,
        Z5CloudCommon,
        CloudCommon,
        PosCommon,
        CrmCommon,
        PosKeepAccount,
        PosDeptPayway,
        PosPayway,
        pagerBar,
        PosDept,
        PosPaywayFeeType,
        PosOtherRec,
        PosBankAccount,
        PosPaywayUser,
        PosMultiOrg,
        PosCustomer,
        PosSupplier,
        PosItem,
        PosItemClass,
        PosItemClassShop,
        PosContactUnit,

        CloudContactUnitAccount,
        CloudContactUnit,
        CloudBankAccount,
        CloudDept,
        CloudBillType,
        CloudBillBusType,
        CloudUnit,
        CloudItem,
        CloudItemClass,
        CloudItemClassDept,
        CloudItemFeeType,
        CloudCustomer,
        CloudSupplier,
        CloudSupplierType,
        CloudWarehouse,
        CloudMultiOrg,
        CloudShop,
        CloudOrgStore,
        CloudOrgSupplier,
        CloudSupplierOrg,
        CloudCustomerShop,
        CloudCustomerPayway,
        CrmShops,
        CrmMultiOrg,
        CrmCustomer,
        CrmBankAccount,
        CrmCardType,
        CrmPayway,
        CrmDeptPayway
    },
    data() {
        return {
            isSCM8: false,
            isSaiHu: false,
            isKeepAccount: false,
            isItemClassDept: false,
            isSupplierOrg: false,
            isZ5: false,
            openloading: true,
            isPos: false,
            isCloud: false,
            isCrm: false,
            isPayway: false,
            isDeptPayway: false,
            isContactUnit: false,
            isContactUnitAccount: false,

            isOtherRec: false,
            isPaywayUser: false,
            isBankAccount: false,
            isPaywayFeeType: false,
            isDept: false,
            isBillType: false,
            isBillBusType: false,
            isUnit: false,
            isItem: false,
            isItemClass: false,
            isItemFeeType: false,
            isCustomer: false,
            isSupplier: false,
            isSupplierType: false,
            isWareHouse: false,
            isMultiOrg: false,
            isOrgStore: false,
            isOrgSupplier: false,
            isCustomerShop: false,
            isItemClassShop: false,
            isCardType: false,
            isShop: false,
            moduleID: this.$route.query.moduleID,
            brandid: this.$route.query.brandId,
            basicType: this.$route.query.id,
            basicModule: this.$route.query.module,
            syncMode: this.$route.query.syncmode
        }
    },
    created: function () {
        this.getName()
    },
    mounted: function () {},
    methods: {
        backTo() {
            // this.$router.push("/bench/index");

            this.$router.push({
                path: '/bench/index',
                query: {
                    moduleID: this.moduleID,
                    brandId: this.brandid
                }
            })
        },
        getName() {
            if (!$.isEmptyObject(this.$route.query)) {
                switch (this.basicType) {
                    case '部门结算方式档案':
                        this.isDeptPayway = true
                        break
                    case '结算方式档案':
                        this.isPayway = true
                        break
                    case '客户支付方式档案':
                    case '会员支付方式档案':
                        this.isPayway = true
                        break
                    case '部门档案':
                        this.isDept = true
                        break
                    case '单据类型档案':
                        this.isBillType = true
                        break
                    case '单位档案':
                        this.isUnit = true
                        break
                    case '品项档案':
                        this.isItem = true
                        break
                    case '品项分类档案':
                        this.isItemClass = true
                        break
                    case '客户档案':
                        this.isCustomer = true
                        break
                    case '供应商档案':
                        this.isSupplier = true
                        break
                    case '供应商分类档案':
                        this.isSupplierType = true
                        break
                    case '仓库档案':
                    case '供应商仓库档案':
                        this.isWareHouse = true
                        break
                    case '多组织档案':
                    case '税率档案':
                        this.isMultiOrg = true
                        break
                    case '组织仓库档案':
                        this.isOrgStore = true
                        break
                    case '组织供应商档案':
                        this.isOrgSupplier = true
                        break

                    case '供应商组织档案':
                        this.isSupplierOrg = true
                        break
                    case '客户门店档案':
                        this.isCustomerShop = true
                        break
                    case '门店档案':
                        this.isShop = true
                        break
                    case '业务类型档案':
                        this.isBillBusType = true
                        break
                    case '品项费用类型档案':
                        this.isItemFeeType = true
                        break
                    case '结算方式费用类型档案':
                        this.isPaywayFeeType = true
                        break
                    case '结算方式员工档案':
                        this.isPaywayUser = true
                        break
                    case '银行账户档案':
                        this.isBankAccount = true
                        break
                    case '应收客户档案':
                        this.isOtherRec = true
                        break
                    case '品项分类门店档案':
                        this.isItemClassShop = true
                        break
                    case '品项分类部门档案':
                        this.isItemClassDept = true
                        break
                    case '往来单位档案':
                        this.isContactUnit = true
                        break
                    case '往来单位科目档案':
                        this.isContactUnitAccount = true
                        break
                    case '记账类别档案':
                        this.isKeepAccount = true
                        break
                    case '卡类型档案':
                        this.isCardType = true
                        break
                    default:
                        this.$message({
                            message: '当前基础档案未在系统内维护',
                            type: 'error'
                        })
                        break
                }
                switch (this.basicModule) {
                    case 'pos':
                    case '餐饮':
                        this.isPos = true
                        break
                    case 'cloud':
                    case '供应链':
                        this.isCloud = true
                        break
                    case 'crm':
                    case '会员':
                        this.isCrm = true
                        break
                    case 'Z5':
                        this.isZ5 = true
                        break
                    case 'SCM8':
                        this.isSCM8 = true
                        break
                    case 'SaiHu':
                        this.isSaiHu = true
                        break
                    default:
                        this.$message({
                            message: '当前基础档案未在系统内维护',
                            type: 'error'
                        })
                        break
                }
            } else {
                this.$router.push('/bench/index')
                this.QueryParams = {}
            }
        },
        openloadingHandler() {
            this.openloading = true
        },
        closeloadingHandler() {
            this.openloading = false
        },
        InitCloudData(data) {
            this.CloudTableData = data
            this.closeloadingHandler()
        },
        InitFinData(data) {
            this.FinTableData = data
            this.closeloadingHandler()
        },
        CloseError() {
            this.closeloadingHandler()
        }
    }
}
</script>

<style scoped="scoped">
dt,
dd {
    margin: 0;
    padding: 0;
}
</style>
